
(function () {

	const initProductAccordion = () => {

		/* SET DEFAULT OPEN ACTIVE */
		$(".about__accordion-item.active")
			.find(".about__accordion-title")
			.addClass("active");

		$(".about__accordion-title").off("click").on("click", function () {

			let parent = $(this).closest(".about__accordion-item");
			let description = parent.find(".about__accordion-description");

			if (!$(this).hasClass("active")) {

				/* CLOSE ALL */
				$(".about__accordion-title.active").removeClass("active");
				$(".about__accordion-item.active").removeClass("active");

				$(".about__accordion-description")
					.stop()
					.slideUp(300);

				/* OPEN CURRENT */
				$(this).addClass("active");
				parent.addClass("active");

				description
					.stop()
					.slideDown(300);

			} else {

				/* CLOSE CURRENT */
				$(this).removeClass("active");
				parent.removeClass("active");

				description
					.stop()
					.slideUp(300);
			}
		});
	};

	document.addEventListener("shopify:section:load", function () {
		initProductAccordion();
	});

	document.addEventListener("DOMContentLoaded", function () {
		initProductAccordion();
	});

	initProductAccordion();

})();

